var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477 262"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M345.606.5l-21.212 21.213 94.393 94.394H0v30h418.787L324.394 240.5l21.212 21.213 130.607-130.607z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDc3IiBoZWlnaHQ9IjI2MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMzQ1LjYwNi41bC0yMS4yMTIgMjEuMjEzIDk0LjM5MyA5NC4zOTRIMHYzMGg0MTguNzg3TDMyNC4zOTQgMjQwLjVsMjEuMjEyIDIxLjIxMyAxMzAuNjA3LTEzMC42MDd6Ii8+PC9zdmc+Cg==";
export { SvgArrowRight as ReactComponent };